export default "__VITE_ASSET__Cmj7VelN__"